import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import WatWeDoenPage from "@/pages/WatWeDoenPage";
import ProjectenPage from "@/pages/ProjectenPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import OverFinPage from "@/pages/OverFinPage";
import VoorGemeentenPage from "@/pages/VoorGemeentenPage";
import SteunPage from "@/pages/SteunPage";
import HulpNodigPage from "@/pages/HulpNodigPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/wat-we-doen" element={<WatWeDoenPage />} />
            <Route path="/projecten" element={<ProjectenPage />} />
            <Route path="/projecten/:slug" element={<ProjectDetailPage />} />
            <Route path="/over-fin" element={<OverFinPage />} />
            <Route path="/voor-gemeenten" element={<VoorGemeentenPage />} />
            <Route path="/steun" element={<SteunPage />} />
            <Route path="/hulp-nodig" element={<HulpNodigPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />

            {/* Legacy redirects */}
            <Route path="/over-ons" element={<Navigate to="/over-fin" replace />} />
            <Route path="/herstel" element={<Navigate to="/wat-we-doen#herstel" replace />} />
            <Route path="/jeugd" element={<Navigate to="/wat-we-doen#groei-kansen" replace />} />
            <Route path="/voor-ouders" element={<Navigate to="/hulp-nodig" replace />} />
            <Route path="/voor-deelnemers" element={<Navigate to="/hulp-nodig" replace />} />
            <Route path="/gemeenten" element={<Navigate to="/voor-gemeenten" replace />} />
            <Route path="/impact" element={<Navigate to="/over-fin" replace />} />
            <Route path="/hulp" element={<Navigate to="/hulp-nodig" replace />} />
            <Route path="/hulp/*" element={<Navigate to="/hulp-nodig" replace />} />
            <Route path="/partners" element={<Navigate to="/voor-gemeenten" replace />} />
            <Route path="/doe-mee" element={<Navigate to="/steun" replace />} />
            <Route path="/aanmelden" element={<Navigate to="/hulp-nodig" replace />} />
            <Route path="/voor-wie" element={<Navigate to="/hulp-nodig" replace />} />
            <Route path="/doelgroepen" element={<Navigate to="/hulp-nodig" replace />} />
            <Route path="/doelgroepen/*" element={<Navigate to="/hulp-nodig" replace />} />
            <Route path="/werkwijze" element={<Navigate to="/over-fin" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>

          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
